import { render, staticRenderFns } from "./TheLanguageSwitcher.vue?vue&type=template&id=70ca439a"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports